require('../../lib/select2/select2-3.4.5/select2.min.js');
require('../../lib/js/angularmodule/JV.Core.Directives');
require('./jv.register.form.controller.js');
require('./jv.register.service.js');
require('./jv.register.sendInvitation.controller.js');

angular.module('jv.register.app', [
    'ngRoute',
    'JV.Core.Directives',
    'jv.register.form.controller',
    'jv.register.service',
    'jv.register.sendInvitation.controller',
    'ui'
]).directive('jvHideinMobile', [function () {
    return {
        restrict: 'C',
        link: function (scope, elm) {
            var div = angular.element(elm);
            scope.$watch('register', function(){
                if(scope.register){
                    scope.register.confirmPasswordDisabled = !$(div).is(':visible');
                }
            },true);
        }
    };
}]).directive('jvPasswordShowHide', [function () {
    return {
        restrict: 'A',
        link: function (scope, elm) {
            var _passwordField = angular.element(elm);
            if($(_passwordField) && $(_passwordField).parent()){
                var _offset = $(_passwordField).offset();
                var icon = $('<i class="icon icon-quick-view blue x-large jv-password-show-hide"></i>');
                icon.css('position', 'absolute');
                icon.css('top', _offset.top + $(elm).height()-10);
                icon.css('left', _offset.left + $(elm).width()-10);
                icon.on('click', function(){
                    var newType = (_passwordField[0].getAttribute('type') === 'password' ? 'text' : 'password');
                    _passwordField[0].setAttribute('type', newType);
                });
                $(_passwordField).parent().append(icon);
            }
        }
    };
}]).factory('jvPasswordPolicyFAC', [function () {
    return function(policyType, value){
        if(value){
            var regEx;
            switch(policyType){
                case 'number':
                    regEx = new RegExp('.*[0-9].*'); //should contain at least one digit
                    break;
                case 'lowercase':
                    regEx = new RegExp('.*[a-z].*'); //should contain at least one lower case
                    break;
                case 'uppercase':
                    regEx = new RegExp('.*[A-Z].*'); //should contain at least one upper case
                    break;
                case 'length':
                    return (value && value.length >= 8); //should contain at least 8 characters
                default:
                    break;
            }
            return regEx && regEx.test(value);
        }
        return false;
    };
}]);